import React from 'react';
import { PropTypes } from 'prop-types';

import { Remarkable } from 'remarkable';

class FaqsWithMarkup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      responseMkd: '',
    };
  }

  componentDidMount() {
    this.fetchText();
  }

  fetchText = async () => {
    const {
      country: { country },
    } = this.props;
    try {
      const response = await fetch(
        `https://raw.githubusercontent.com/wiki/ontruck/FAQ-SA/${country}-faq.md`
      );
      const responseMkd = await response.text();
      this.setState({ responseMkd });
    } catch (e) {
      console.log(e);
    }
  };

  renderText = () => {
    const md = new Remarkable('full', { linkify: true });
    const { responseMkd } = this.state;
    return { __html: md.render(responseMkd) };
  };

  render() {
    const { className } = this.props;
    return (
      <div className={className}>
        <section>
          <div className="faqs-content">
            <div dangerouslySetInnerHTML={this.renderText()} />
          </div>
        </section>
      </div>
    );
  }
}

FaqsWithMarkup.propTypes = {
  className: PropTypes.string,

  country: PropTypes.string,
};

FaqsWithMarkup.defaultProps = {
  className: '',

  country: '',
};

export default FaqsWithMarkup;
